import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const ReadingPaneIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 21.5 17.05",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 17.5),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    children: [/*#__PURE__*/jsxs("g", {
      transform: "translate(.75 8.61)",
      children: [/*#__PURE__*/jsx("path", {
        d: "m3.85 0a3.85 3.85 0 1 1 -3.85 3.85 3.85 3.85 0 0 1 3.85-3.85z"
      }), /*#__PURE__*/jsxs("g", {
        strokeLinejoin: "round",
        children: [/*#__PURE__*/jsx("circle", {
          cx: "16.15",
          cy: "3.85",
          r: "3.85"
        }), /*#__PURE__*/jsx("path", {
          d: "m7.7 3.92c0-.85 1.03-1.54 2.3-1.54s2.3.69 2.3 1.54"
        })]
      })]
    }), /*#__PURE__*/jsx("path", {
      d: "m.75 12.05v-9.6l1.9-1.4"
    }), /*#__PURE__*/jsx("path", {
      d: "m20.75 12.05v-9.6l-1.87-1.4"
    })]
  });
};

export { ReadingPaneIcon };
//# sourceMappingURL=reading-pane.js.map
